import React, { Component } from 'react'
import { Input } from '@driftt/tide-core-legacy'

class SalesforceLeadRoutingRadioDisplay extends Component {
  render() {
    const { accountLookupChecked,
      contactLookupChecked,
      accountLookupOnClick,
      contactLookupOnClick } = this.props
    return(
      <table className="account-radio-options-table">
        <tbody>
          <tr className="account-radio-options-table account-lookup-radio-options-row">
            <td>
              <span>How should we look up this Account?</span>
            </td>
          </tr>
          <tr className="account-lookup-radio-options-row">
            <td>
              <Input
                type="radio"
                label="Find contact by email, then find Account associated with that Contact"
                className="sfdc-contact-lookup-radio"
                checked={contactLookupChecked}
                onClick={contactLookupOnClick}
              />
            </td>
          </tr>
          <tr className="account-radio-options-table account-lookup-radio-options-row">
            <td>
              <Input
                type="radio"
                label="Find the Account whose website matches the email domain"
                className="sfdc-account-lookup-radio"
                checked={accountLookupChecked}
                onClick={accountLookupOnClick}
              />
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default SalesforceLeadRoutingRadioDisplay



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/SalesforceFilter/SalesforceLeadRoutingRadioDisplay.js